import { Link } from 'react-router-dom';

interface PageHeroProps {
  title: string;
  subtitle: string;
  image: string;
  imageAlt: string;
  breadcrumb: string;
}

const PageHero = ({ title, subtitle, image, imageAlt, breadcrumb }: PageHeroProps) => {
  return (
    <section className="relative h-[70vh] min-h-[500px] flex items-end pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20" />
      </div>

      {/* Breadcrumb */}
      <div className="absolute top-28 left-6 z-10 flex items-center gap-2 text-white/70 text-sm">
        <Link to="/" className="hover:text-white transition-colors">Accueil</Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-white">{breadcrumb}</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-gold" />
            <span className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase">Ev &amp; Co Design</span>
          </div>
          <h1 className="font-serif text-4xl lg:text-6xl text-white leading-tight mb-4">{title}</h1>
          <p className="text-white/80 text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
